/*
 * @Author: my
 * @Date: 2022-05-16 14:32:11
 * @LastEditors: my
 * @LastEditTime: 2022-05-16 14:32:21
 */
import {ajax} from '@/request'
export function wx_auth(param={}){
  return ajax('/wxb/exam/wx_auth',param)
}
export function get_question(param={}){
  return ajax('/wxb/exam/get-question',param)
}
export function works_add(param={}){
  return ajax('/wxb/exam/save-info',param)
}
export function update_score(param={}){
  return ajax('/wxb/exam/add-answer',param)
}
export function draw(param={}){
  return ajax('/wxb/exam/draw',param)
}
export function winninginfo(param={}){
  return ajax('/wxb/exam/winning-info',param)
}